import React from 'react';
import { Container, Box, Typography } from '@mui/material';

const ComingSoon = () => {
  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Box 
        sx={{ 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: 'center', 
          justifyContent: 'center', 
          height: '60vh', // Center it vertically
          textAlign: 'center', 
        }}
      >
        <Typography variant="h2" gutterBottom sx={{ color: '#23347c' }}> {/* Heading Style */}
          Coming Soon!
        </Typography>
        <Typography variant="body1" sx={{ color: '#555', mt: 2 }}>
          Stay tuned for updates.
        </Typography>
      </Box>
    </Container>
  );
};

export default ComingSoon;
